import { ConfigProvider, PortalThemeProvider } from '@fuze/portal-core';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { brand } from '@/content';

import type { AppServices } from './boot';
import { Experimentation } from './flags/experimentation';
import { ReportingProvider } from './observability/ReportingContext';

export type AppProvidersProps = { services: AppServices; children: ReactNode };

/**
 * Everything below the router needs config, reporting, flags, the query client (boot.ts creates them) and the
 * Nexus theme in the program's brand.
 */
export const AppProviders = ({ services, children }: AppProvidersProps) => (
  <ConfigProvider config={services.config}>
    <PortalThemeProvider brand={brand}>
      <ReportingProvider reporter={services.reporter}>
        <Experimentation.Provider client={services.experimentation}>
          <QueryClientProvider client={services.queryClient}>{children}</QueryClientProvider>
        </Experimentation.Provider>
      </ReportingProvider>
    </PortalThemeProvider>
  </ConfigProvider>
);
